import React, { useState } from "react";
import ColorsMain from "../../colors/ColorsMain";

const ButtonCheckBoxTransparent = ({ label, setValue = () => { }, value, error = false, }) => {
  const [isSelected, setIsSelected] = useState(value);

  const handleCheckboxChange = () => {
    setIsSelected(!isSelected);
    setValue(!isSelected);
  };

  return (
    <div className={`flex items-center gap-3 p-4 rounded-2xl    `}>
      <input
        type="checkbox"
        id={label}
        checked={value}
        onChange={handleCheckboxChange}
        className="hidden" // Ocultamos el checkbox
      />
      <label
        htmlFor={label}
        className={`w-5 h-5 flex items-center justify-center border ${error ? `border-[#ff928b]` : `border-[${ColorsMain.bgMain}]`}  rounded-md cursor-pointer ${isSelected ? `bg-[${ColorsMain.borderGray}]` : `bg-[${ColorsMain.borderGray}]`
          }`}
      >
        {value && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`w-4 h-4 text-[${ColorsMain.texttMain}]`}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        )}
      </label>
      <span

        style={{
          color: ColorsMain.texttMain,
        }}
      >
        {label}
      </span>
    </div >
  );
};

export default ButtonCheckBoxTransparent;
